import { render, staticRenderFns } from "./FlowNodeJumpRule.vue?vue&type=template&id=5864f3e2&scoped=true&"
import script from "./FlowNodeJumpRule.vue?vue&type=script&lang=js&"
export * from "./FlowNodeJumpRule.vue?vue&type=script&lang=js&"
import style0 from "./FlowNodeJumpRule.vue?vue&type=style&index=0&id=5864f3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5864f3e2",
  null
  
)

export default component.exports